import { motion } from "framer-motion";
import { MdGridView } from "react-icons/md";

export const SingleProductSekeleton = () => {
  return (
    <motion.div
      whileTap={{ rotate: [0, -1, 1, -1, 0] }}
      className={`w-[275px] min-w-[275px] md:w-[300px] md:min-w-[300px] my-12 h-auto bg-cardOverlay rounded-lg p-2 px-3 backdrop-blur-lg hover:drop-shadow-sm cursor-pointer`}
    >
      <div className="flex items-center justify-between w-full">
        <div className="object-contain w-40 h-40 -mt-8 cursor-pointer md:w-48 md:h-40"></div>

        <motion.div
          whileTap={{ scale: 1.1 }}
          whileHover={{ scale: 1.2 }}
          className="flex items-center justify-center w-8 h-8 bg-red-600 rounded-full cursor-pointer md:w-10 md:h-10"
          onClick={() => {}}
          title="Add to cart"
        >
          <MdGridView className="text-white md:text-xl" />
        </motion.div>
      </div>
      <div className="flex flex-col items-end justify-end w-full">
        <div className="w-4/5 h-6 bg-gray-300 rounded-full animate-pulse opacity-8"></div>
        <div className="w-full bg-gray-300 rounded-full animate-pulse opacity-8 my-2 h-3 lg:my-3 line-clamp-1 max-w-[200px] opacity-8" />
        <div className="w-1/4 bg-gray-300 rounded-full animate-pulse opacity-8 my-2 h-6 lg:my-3 line-clamp-1 max-w-[200px] opacity-8"></div>
      </div>
    </motion.div>
  );
};
